import type {
  GetDeliveryDatesQuery,
  GetDeliveryDatesQueryVariables,
} from '@app/data/shop-bff';
import { publicShopBffSdk } from '@app/utils/common';
import { STATIC_ASSETS_BASE } from '@redbubble/next-seo/constants';
import { useCallback, useState } from 'react';

export type DeliveryDates = GetDeliveryDatesQuery['shop_deliveryDates'];

export const useDeliveryDates = () => {
  const [{ deliveryDates, loading }, setDeliveryDates] = useState<{
    deliveryDates: DeliveryDates;
    loading: boolean;
  }>({
    deliveryDates: null,
    loading: true,
  });

  const refresh = useCallback((variables: GetDeliveryDatesQueryVariables) => {
    setDeliveryDates({ deliveryDates: null, loading: true });

    publicShopBffSdk
      .GetDeliveryDates(variables)
      .then((res) => {
        setDeliveryDates({
          deliveryDates: res.shop_deliveryDates,
          loading: false,
        });
      })
      .catch(() => {
        // TODO: Handle errors
        setDeliveryDates({
          deliveryDates: null,
          loading: false,
        });
      });
  }, []);

  return {
    deliveryDates,
    loading,
    refresh,
  };
};

export const getFlagSvgFromPublicAssets = (countryCode: string) => {
  const lowerCaseCode = countryCode.toLowerCase();
  return `${STATIC_ASSETS_BASE}/flags/4x3/${lowerCaseCode}.svg`;
};
